// @flow

import { DraftLiveStateEnum } from "@modules/service/constants";
import type { DynamicQuestionsState } from "./types";

export const initialState: DynamicQuestionsState = {
  requestsInProgress: 0,
  list: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  schema: null,
  current: null,
  draft: null,
  assignments: [],
  draftAssignments: [],
  configuration: {
    enabled: true,
    status: DraftLiveStateEnum.LIVE,
  },
  modals: {
    showAddDynamicQuestionModal: false,
    modalStep: 1,
    showEditModal: false,
    showEditAssignmentsModal: false,
  },
};

export default initialState;
